import { isDefined } from './is-defined.guard';

/**
 * Executes a callback function if the provided value is defined (not `null` or `undefined`).
 *
 * @typeParam T - The type of the input value.
 * @typeParam TReturnValue - The type of the return value from the callback.
 * @param value - The value to check for definition.
 * @param callback - The function to execute if `value` is defined. Receives the defined value as its argument.
 * @returns The result of the callback if `value` is defined; otherwise, `undefined`.
 */
export const ifDefined = <T = unknown, TReturnValue = unknown>(
  value: T | null | undefined,
  callback: (value: T) => TReturnValue
): TReturnValue | undefined => {
  const defined = isDefined(value);

  if (!defined) {
    return;
  }

  return callback(value);
};
